import { useContext, useEffect } from 'react';
import { MainContext } from '..';
import { observer } from 'mobx-react-lite';

// Установка пациента
export const usePatient = (patientId, setPatient) => {
    const { medicalStore } = useContext(MainContext);

    useEffect(() => {
        setPatient(medicalStore.patients.find((p) => p.id === patientId));
    }, [medicalStore.patients, patientId]);
};

